import type { AppState } from 'types/app';

// Can return `true`, `false`, or `null` (if unknown)
export const selectAuthentication = (state: AppState) => state.authentication;
